module.exports = __webpack_public_path__ + "img/thumbnail_RedNeckedWallaby_m_normal.fa127083.png";